import React, { useEffect, useState } from 'react'
import AccountLayout from '../../../../../layout/components/AccountLayout'
import TransactionForm from '../components/TransactionForm'
import { Link } from 'react-router-dom'


function TransactionDashboardPage() {

  

  
  const callBack =() =>{

  }



  return (
    <AccountLayout>
      <div className='row'>
        <div className='col-md-12'>
          <span className='float-end'>
            <Link to={"/transaction/list"} className='btn btn-outline-primary me-2'>Transaction List</Link>
            <Link to={"/transaction/item-list"} className='btn btn-outline-primary me-2'>Transaction Item  List</Link>
            <TransactionForm callBack={callBack} />
          </span>
        </div>
      </div>
      
      <div className='row'>
        <div className='col-md-12'>
          
        </div>
      </div>
    </AccountLayout>
  )
}

export default TransactionDashboardPage